export default {"src":"/_next/static/media/bg_purple_gradient.09818fd6.svg","height":379,"width":1440,"blurWidth":0,"blurHeight":0};